/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import Button from '../elements/Button';

const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Our Apps', href: '/project' },
  { label: 'Team', href: '/team' },
  { label: 'Partner With Us', href: '/#partner' },
];

const capabilities = [
  'AI/ML Integration',
  'Mobile Development',
  'UI/UX Design',
  'App Publishing',
  'Cloud Infrastructure',
  'Maintenance & Support',
];

export default function Footer() {
  return (
    <footer className="bg-theme-blue text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand & Description */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <p className="text-3xl font-medium">
                Drava
                <span className="text-theme-purple">studio</span>
              </p>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Building AI-powered mobile experiences that transform industries.
              Partner with us to bring your vision to life.
            </p>

          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Button
                    href={link.href}
                    isExternal={link.href.startsWith('/#')}
                    type="link"
                    className="text-gray-300 hover:text-white hover:pl-2 transition-all duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          {/* Capabilities */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Our Capabilities</h3>
            <ul className="space-y-3">
              {capabilities.map((cap) => (
                <li key={cap} className="text-gray-300 flex items-center gap-2">
                  <svg className="w-4 h-4 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {cap}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-theme-purple mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <div>
                  <p className="text-gray-400 text-sm">Business Inquiries</p>
                  <a href="mailto:business@drava.tech" className="text-white hover:text-theme-purple transition-colors cursor-pointer">
                    business@drava.tech
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-theme-purple mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="text-gray-400 text-sm">Headquarters</p>
                  <p className="text-white">
                    Suite C, Level 7, WorldTrust Tower
                    <br />
                    50 Stanley Street, Central
                    <br />
                    Hong Kong
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Drava Studio. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <a href="/privacy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="/terms" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
